import React, { useEffect } from 'react';
import Modal from 'react-modal';
import { observer } from 'mobx-react';
import { Box } from '@material-ui/core';
import { useStores } from '../../hooks/use-stores';
import { CloseBtn, Title } from '../UI/Modal';
import { fields } from './fields';
import PreloadButton from '../../interface/PreloadButton';

const BuyOrderModal = observer(({ open, onClose }) => {
    const { OrderStore: store, ProductStore, ProfileDataStore } = useStores();

    // Effects
    useEffect(() => {
        if (open && !ProfileDataStore.profile) {
            ProfileDataStore.getProfile();
        }
    }, [ProfileDataStore, open]);

    // Autofills
    useEffect(() => {
        const { fio, company } = ProfileDataStore.profile || {};

        store.setValues({
            companyName: company?.title,
            contactPerson: fio,
            modelName: ProductStore.product?.name,
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ProfileDataStore.profile]);

    // Renders
    const renderFields = () => {
        const fieldNames = [
            { type: 'input', name: 'name' },
            { type: 'input', name: 'phone' },
            { type: 'input', name: 'modelName' },
            { type: 'checkbox', name: 'usePrivileges' },
            { type: 'textarea', name: 'comment' },
        ];

        return fieldNames.map(({ name, type }, index) => {
            if (fields[name]) {
                switch (type) {
                    case 'input':
                    case 'textarea':
                        return (
                            <Box mb={3} key={index}>
                                {fields[name](name, store.values[name], store.handleInputChange)}
                            </Box>
                        );

                    case 'checkbox':
                        return <Box key={index}>{fields[name](name, store.values[name], store.handleCheckboxChange)}</Box>;

                    default:
                        return null;
                }
            }

            return null;
        });
    };

    // Handlers
    const handleSubmit = e => {
        e.preventDefault();

        store.sendOrderToBuy(ProductStore.product?.id, onClose);
    };

    // Render
    return (
        <Modal
            isOpen={open}
            onClose={onClose}
            onRequestClose={onClose}
            className="Modal order-modal"
            shouldCloseOnOverlayClick={false}
            shouldCloseOnEsc={false}
            ariaHideApp={false}
        >
            <CloseBtn onClose={onClose} />
            <Box mb={3}>
                <Title align="center">Купить {ProductStore.product.name}</Title>
            </Box>

            <form onSubmit={handleSubmit}>
                {renderFields()}

                <PreloadButton isLoad={store.loading}>Отправить</PreloadButton>
            </form>
        </Modal>
    );
});

export default BuyOrderModal;
